'use client'

import type { MulticityJourneyLabel } from '@/src/hooks/srp/multicity/useMulticityJourneyLabels'
import { Box, Button, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'

type MulticityJourneySegmentTabsProps = {
    journeys: MulticityJourneyLabel[]
    selectedIndex: number
    onSelect: (index: number) => void
}

const MulticityJourneySegmentTabs = ({ journeys, selectedIndex, onSelect }: MulticityJourneySegmentTabsProps) => {
    // const locale = useLocale()
    // const isArabic = locale === 'ar'
    const t = useTranslations('srpFilters')

    if (journeys.length <= 1) {
        return null
    }

    return (
        <Box
            sx={{
                display: 'grid',
                gridTemplateColumns: 'repeat(2, 1fr)',
                gap: 1,
                mb: 1.5,
            }}
        >
            {journeys.map((journey, index) => {
                const isSelected = selectedIndex === index
                const routeLabel = journey.from && journey.to ? `(${journey.from} - ${journey.to})` : ''

                return (
                    <Button
                        key={index}
                        variant="outlined"
                        onClick={() => onSelect(index)}
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            p: 0,
                            borderRadius: 1,
                            textTransform: 'none',
                            minHeight: 36,
                            ...(isSelected
                                ? {
                                    borderColor: 'link.main',
                                    color: 'link.main',
                                    bgcolor: 'primary.100',
                                    boxShadow: 'none'
                                }
                                : {
                                    borderColor: 'grey.200',
                                    bgcolor: 'background.default',
                                    color: 'grey.600'
                                })
                        }}
                    >
                        <Typography variant={isSelected ? "body2" : "caption"} sx={{ fontSize: '12px', fontWeight: 600 }}>
                            {t('flightNumber', { number: index + 1 })}{routeLabel && <> {routeLabel}</>}
                        </Typography>

                    </Button>
                )
            })}
        </Box>
    )
}

export default MulticityJourneySegmentTabs
